import { SidePanelLayerType } from "@nova/constants"
import { createSelector } from "@reduxjs/toolkit"
import {
    selectLastSelectedLayerId,
    selectSelectedLayers,
} from "panels/content/side-panel/slice.new"

export const selectActiveIconId = createSelector(
    [selectLastSelectedLayerId, selectSelectedLayers],
    (lastSelectedLayerId, selectedLayers) =>
        selectedLayers.find((layer) => layer.id === lastSelectedLayerId)?.type ===
        SidePanelLayerType.Icon
            ? lastSelectedLayerId
            : undefined
)
